import { LoginManagementRoutes } from "../LoginManagementRoutes";

const ROOT = LoginManagementRoutes.CARDTAN;

export const CardTanSettingsRoutes = {
    ROOT,
    ONBOARDING_LIMIT: ROOT + "/limit",
    ONBOARDING_LIMIT_SIGNING: ROOT + "/limit/signing",
    ONBOARDING_LIMIT_SUCCESS: ROOT + "/limit/success",
    LIMIT: ROOT + "/limit-management",
    LIMIT_SIGNING: ROOT + "/limit-management/signing",
    LIMIT_SUCCESS: ROOT + "/limit-management/success",
    CARDS: ROOT + "/cards",
    NEW_DEVICE: ROOT + "/new-device",
    NEW_DEVICE_SIGNING: ROOT + "/new-device-signing",
    NEW_DEVICE_SUCCESS: ROOT + "/new-device-success",
    NEW_DEVICE_ERROR_NO_OFFER: ROOT + "/new-device-error-unavailable",
    CARDS_SIGNING: ROOT + "/cards-signing",
    CARDS_SUCCESS: ROOT + "/cards-success",
    CARDS_ERROR: ROOT + "/cards-error",
    CHANGE_PIN: ROOT + "/pin",
    CHANGE_PIN_SIGNING: ROOT + "/pin-signing",
    CHANGE_PIN_SUCCESS: ROOT + "/pin-success",
    CHANGE_PIN_ERROR: ROOT + "/pin-error",
    USERMANAGEMENT_USERNAME: ROOT + "/username",
    USERMANAGEMENT_USERNAME_SIGNING: ROOT + "/username-signing",
    USERMANAGEMENT_USERNAME_SUCCESS: ROOT + "/username-success",
    USERMANAGEMENT_DELETE_USERNAME_SIGNING: ROOT + "/delete-username-signing",
    USERMANAGEMENT_DELETE_USERNAME_SUCCESS: ROOT + "/delete-username-success",
    ERROR_SIGNING_METHOD: ROOT + "/error-signing-method",
    ACTIVATE_GEORGE_ID: ROOT + "/activate-george-id",
    ACTIVATE_GEORGE_ID_SIGNING: ROOT + "/activate-george-id-signing",
    ACTIVATE_GEORGE_ID_SUCCESS: ROOT + "/activate-george-id-success",
    NEW_ADDRESS: ROOT + "/new-address",
    UPDATE_ADDRESS: ROOT + "/update-address"
};



// WEBPACK FOOTER //
// ./src/components/loginManagement/cardTanSettings/CardTanSettingsRoutes.ts